export const transparencia_item = [
    {
        "transparencia_item_nombre" : "Art 69 Ley de Transparencia (48 Rubros)",
        "transparencia_item_url" : "Rubros"
    },
    // {
    //     "transparencia_item_nombre" : "Art 70 Ley de Transparencia",
    //     "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/Docs/xlsx/a70_f01_g SADERH.xlsx"
    // },
    {
        "transparencia_item_nombre" : "Calendario Presupuestal 2026 Enero-Septiembre",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura//dir1/SADERH/2026/DocsPagweb/Presupueto2026.pdf"
     },
     {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios 2026",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura//dir1/SADERH/2026/DocsPagweb/PAAAS2026.pdf"
     },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios 2025",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura//dir1/SADERH/2025/DocsPagweb/PAAAS2025Final.pdf"
     },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios 2024",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/PAAS/PAAS_2024.pdf"
     },
    {
        "transparencia_item_nombre" : "Programa Anual de Adquisiciones, Arrendamientos de Bienes Muebles y Servicios 2023",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/PAAS/PAAS2023.pdf"
    },
   
    {
        "transparencia_item_nombre" : "Matriz de Indicadores para Resultados Ejercicio Fiscal",
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/PAAS 2021.pdf"
    },

]

export const pada_item = [
    {
        "pada_item_nombre" : "PADA 2026",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/Transparencia/PADA/PADA2026.pdf"
    },

    {
        "pada_item_nombre" : "INFORME PADA 2025",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/PADA/InformePADA2025.pdf"
    },
    {
        "pada_item_nombre" : "PADA 2025",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/PADA/PADA2025.pdf"
    },
    {
        "pada_item_nombre" : "INFORME PADA 2024",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Transparencia/PADA/InformePADA2024.pdf"
    },
   
    {
        "pada_item_nombre" : "PADA 2024",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/PADA/PADA2024.pdf"
    },
    {
        "pada_item_nombre" : "INFORME PADA 2023",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2024/Transparencia/PADA/InformePADA2023.pdf"
    },
    {
        "pada_item_nombre" : "PADA 2023",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/PADA2023.PDF"
    },
    {
        "pada_item_nombre" : "PADA 2022",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/PADA_2022.pdf"
    },
    {
        "pada_item_nombre" : "INFORME PADA 2022",
        "pada_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/InformePADA2022.pdf"
    },
    
    
    {
        "pada_item_nombre" : "INSTRUMENTOS ARCHIVÍSTICOS",
        "pada_item_url" : "../InstrumentosArchivisticos"
    },
    

]